import React from "react";
import { Modal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { CreateCollectionForm } from "./CreateCollectionForm";
var CreateCollectionInlineModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onCreated = _a.onCreated;
    var formatMessage = useIntl().formatMessage;
    var label = formatMessage({
        id: "ui-br-agency.title.collections.form.createCollection.modal.title",
    });
    return (React.createElement(Modal, { open: open, onClose: onClose, label: label, size: "large", dismissible: true }, open && (React.createElement(CreateCollectionForm, { onCreated: onCreated, onCancel: onClose }))));
};
export { CreateCollectionInlineModal };
